export const costs = [
    {
        id: 0,
        name: "Geral de Contas",
        description: "Relatório geral com as informações de todas as contas pagas e a pagar do estabelecimento.",
        code: "geral_de_contas"
    },
    {
        id: 1,
        name: "Segregação dos custos fixos e variáveis",
        description: "Relatório com a consolidação das informações dos custos do estabelecimento.",
        code: "segregacao"
    },
    {
        id: 2,
        name: "Custos por categoria",
        description: "Relatório com a consolidação das contas pagas por categoria.",
        code: "custos_por_categoria"
    }
]